import React from 'react'
import { cn } from 'cn'
import FieldDescription from 'components/ui/FieldDescription'
import FieldError from 'components/ui/FieldError'

export type Props = {
  label?: string
  description?: string | React.ReactElement | null
  placeholder?: string
  error?: string | null
  rows?: number
  className?: string
  newDesign?: boolean
} & React.DetailedHTMLProps<
  React.InputHTMLAttributes<HTMLTextAreaElement>,
  HTMLTextAreaElement
>

export default function TextAreaField({
  label,
  description,
  placeholder,
  error,
  className,
  newDesign,
  ...inputProps
}: Props) {
  return (
    <div className="w-full">
      {label && (
        <label
          className={cn('block', {
            'text-base font-medium text-gray-700': !newDesign,
            'font-theme-heading font-bold text-gray-900': newDesign
          })}
          htmlFor={inputProps.name}
        >
          {label}
        </label>
      )}
      <FieldDescription newDesign={newDesign}>{description}</FieldDescription>
      <textarea
        className={cn(
          'border border-solid border-gray-300 p-2 outline-none-mouse focus:ring-orange-500 focus:border-orange-500 block w-full shadow-xs rounded-xl scroll-offset',
          { 'ring-red-500 border-red-500': error, 'mt-1': label },
          className || ''
        )}
        placeholder={placeholder}
        {...inputProps}
      />
      <FieldError>{error}</FieldError>
    </div>
  )
}
